import axios from "axios";

export const googleLogin = async (url, queryString) => {
  try {
    return await axios({
      method: "get",
      url: url + queryString,
      withCredentials: true,
    });
  } catch (e) {
    throw e;
  }
};
